import {GameRandom, Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";
import {DinnerModel} from "../Models/DinnerModel";
import {FoodModel, FoodStateEnum} from "../Models/FoodModel";

@Singleton
export class DinnerLogic {

    constructor(@Inject private _model: DinnerModel,
                @Inject private _modelEvents: ModelEvents,
                @Inject private _random: GameRandom) {
    }

    public reset(): void {
        this._model.coffee.state = FoodStateEnum.full;
        this._model.sandwich.state = FoodStateEnum.full;
    }

    public eat(foodModel: FoodModel): void {

        --foodModel.state;

        this._model.sandwich.state === FoodStateEnum.empty
        && this._model.coffee.state === FoodStateEnum.empty
        && this._modelEvents.dispatch(this._model, "win");
    }

}
